<template>
  <b-modal
    id="modal-add-bookmark"
    centered
    :title="header ? header : 'Add Bookmark'"
    hide-footer
    size="sm"
    :no-close-on-backdrop="true"
  >
    <b-form @submit.prevent="submit">
      <b-form-group id="input-group-bookmark">
        <b-form-input
          id="input-bookmark"
          v-model="bookmark"
          v-validate="{ required: true, max: 100 }"
          autofocus
          type="text"
          placeholder="Description"
          size="md"
          data-vv-name="bookmark"
        ></b-form-input>
      </b-form-group>

      <b-row>
        <b-col class="text-right">
          <b-btn variant="primary" type="submit">Submit</b-btn>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
export default {
  name: "AddBookmarkModal",
  components: {},
  props: {
    header: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      bookmark: null
    };
  },
  computed: {},
  methods: {
    submit() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$toasted.show(this.$validator.errors.items[0].msg, {
            type: "error"
          });
          return false;
        }

        this.$bvModal.hide("modal-add-bookmark");
        this.$emit("submit", this.bookmark);

        this.bookmark = null;
      });
    }
  }
};
</script>
